(function() {
	'use strict';
	
	document.addEventListener('DOMContentLoaded', function() {
		// Reorganize nested columns to be direct children of .mega-menu-content (grid container)
		function reorganizeNestedColumns() {
			var contentAreas = document.querySelectorAll('.mega-menu-content');
			contentAreas.forEach(function(contentArea) {
				// Find the first level columns container (no data-parent-item-id)
				var mainColumns = contentArea.querySelector('.mega-menu-columns:not([data-parent-item-id])');
				if (!mainColumns) return;
				
				// First, move all level 2 columns (have data-parent-item-id and class --2)
				var level2Columns = contentArea.querySelectorAll('.mega-menu-columns--2[data-parent-item-id]');
				level2Columns.forEach(function(nestedColumn) {
					// Only move if it's not already a direct child of contentArea
					if (nestedColumn.parentElement !== contentArea) {
						// Move to be a direct child of contentArea (after the first level columns)
						contentArea.insertBefore(nestedColumn, mainColumns.nextSibling);
					}
				});
				
				// Then, move all level 3 columns (after level 2 columns)
				var level3Columns = contentArea.querySelectorAll('.mega-menu-columns--3[data-parent-item-id]');
				level3Columns.forEach(function(nestedColumn) {
					// Only move if it's not already a direct child of contentArea
					if (nestedColumn.parentElement !== contentArea) {
						// Find the last level 2 column or use mainColumns as reference
						var lastLevel2 = contentArea.querySelector('.mega-menu-columns--2[data-parent-item-id]:last-of-type');
						var referenceNode = lastLevel2 ? lastLevel2.nextSibling : mainColumns.nextSibling;
						if (referenceNode) {
							contentArea.insertBefore(nestedColumn, referenceNode);
						} else {
							contentArea.appendChild(nestedColumn);
						}
					}
				});
			});
		}
		
		// Reorganize nested columns after a short delay to ensure menu is fully rendered
		setTimeout(function() {
			reorganizeNestedColumns();
		}, 100);
		
		// Find all navigations (in case there are multiple)
		var navs = document.querySelectorAll('.main-navigation, #site-navigation, nav');
		if (!navs.length) return;
		
		// Collect all menu items with dropdowns from all navigations
		var topLevelItems = [];
		var timeout;
		
		navs.forEach(function(nav) {
			// Multiple selectors to catch all possible menu structures
			var items = nav.querySelectorAll('.has-mega-menu, .has-dropdown, .menu-item-has-children, .top-level-item.menu-item-has-children, li.menu-item-has-children');
			
			items.forEach(function(item) {
				// Only process direct children of the main menu (depth 0)
				var parent = item.parentElement;
				if (parent && (
					parent.classList.contains('flex') || 
					parent.id === 'desktop-main-menu' ||
					parent.classList.contains('menu')
				)) {
					topLevelItems.push(item);
				}
			});
		});
		
	// Setup click events for top-level items (click-to-open, not hover)
	topLevelItems.forEach(function(item) {
		var dropdown = item.querySelector('.mega-menu-dropdown, .sub-menu');
		if (!dropdown) return;
		
		var link = item.querySelector('a');
		
		// Click on menu link - toggle dropdown (prevent navigation)
		if (link) {
			link.addEventListener('click', function(e) {
				// Only prevent default if item has dropdown
				if (dropdown) {
					e.preventDefault();
					e.stopPropagation();
					
					clearTimeout(timeout);
					
					var isOpen = item.classList.contains('is-open');
					
					// Close all other dropdowns
					topLevelItems.forEach(function(other) {
						other.classList.remove('is-open');
					});
					
					// Toggle current one
					if (!isOpen) {
						item.classList.add('is-open');
					}
				}
			});
		}
		
		// Also handle focus for accessibility (keyboard navigation)
		if (link) {
			link.addEventListener('focus', function() {
				clearTimeout(timeout);
				// Don't auto-open on focus, but keep track
			});
		}
	});

		// Helpers
		function closeAllDesktopMegaMenus() {
			topLevelItems.forEach(function(item) {
				item.classList.remove('is-open');
				// Also reset nested state so it doesn't flash on next open
				var nestedOpenItems = item.querySelectorAll('.is-nested-open');
				nestedOpenItems.forEach(function(nested) {
					nested.classList.remove('is-nested-open');
				});

				var dropdown = item.querySelector('.mega-menu-dropdown');
				if (dropdown) {
					var visibleCols = dropdown.querySelectorAll('.mega-menu-columns.is-visible');
					visibleCols.forEach(function(col) {
						col.classList.remove('is-visible');
					});
				}
			});
		}

		function closeMobileNavigationIfOpen() {
			var mobileNavigation = document.getElementById('mobile-navigation');
			if (!mobileNavigation || !mobileNavigation.classList.contains('active')) return;

			mobileNavigation.classList.remove('active');
			mobileNavigation.classList.add('hidden');

			// Sync any toggle buttons (we support multiple toggles)
			var toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
			toggles.forEach(function(btn) {
				btn.classList.remove('active');
				btn.setAttribute('aria-expanded', 'false');
			});
		}

		// Close menu immediately when a real navigation link is clicked
		// (so the mega menu doesn't remain visible until the next page loads)
		document.addEventListener('click', function(e) {
			// If another handler already used this click to open a submenu, don't close anything.
			if (e.defaultPrevented) return;

			var link = e.target.closest('a');
			if (!link) return;

			// Ignore back button / non-navigation controls
			if (link.closest('.mega-menu-back-button')) return;

			var href = (link.getAttribute('href') || '').trim();
			if (!href || href === '#' || href.indexOf('javascript:') === 0 || href.indexOf('#') === 0) return;

			// Desktop mega menu: close immediately
			if (link.closest('#desktop-main-menu .mega-menu-dropdown, #desktop-main-menu .sub-menu')) {
				closeAllDesktopMegaMenus();
				return;
			}

			// Mobile navigation: close whole mobile drawer on leaf navigation
			if (link.closest('#mobile-navigation')) {
				closeMobileNavigationIfOpen();
			}
		});
		
		// Nested submenu items (within mega menu) - Desktop only
		// Exclude mobile menus to prevent interference
		var nestedItems = document.querySelectorAll('#desktop-main-menu .mega-menu-dropdown .has-nested-submenu, #desktop-main-menu .mega-menu-list .has-nested-submenu');
		var nestedTimeout;
		var NESTED_COLUMN_CLOSE_MS = 280;
		
		nestedItems.forEach(function(item) {
			// Skip if this is inside a mobile menu
			if (item.closest('.mobile-mega-menu')) return;
			
			// Extract menu item ID from class name (e.g., "menu-item-8817")
			var classMatch = item.className.match(/menu-item-(\d+)/);
			var parentItemId = classMatch ? classMatch[1] : null;
			
			if (!parentItemId) return;
			
			// Find the content area for this item's mega menu
			var megaMenuDropdown = item.closest('.mega-menu-dropdown');
			var contentArea = megaMenuDropdown ? megaMenuDropdown.querySelector('.mega-menu-content') : null;
			
			item.addEventListener('mouseenter', function() {
				clearTimeout(nestedTimeout);
				
				// Hide all other level 2 columns (but keep level 3 columns if they're children of the target level 2)
				if (contentArea) {
					var allLevel2Columns = contentArea.querySelectorAll('.mega-menu-columns--2');
					allLevel2Columns.forEach(function(col) {
						// Only hide if it's not the target column
						var colParentId = col.getAttribute('data-parent-item-id');
						if (colParentId !== parentItemId) {
							col.classList.remove('is-visible');
							// Also hide any level 3 columns that belong to this level 2
							var level3Children = contentArea.querySelectorAll('.mega-menu-columns--3');
							level3Children.forEach(function(level3) {
								// Check if this level 3 belongs to the level 2 we're hiding
								var level3ParentId = level3.getAttribute('data-parent-item-id');
								var level2Items = col.querySelectorAll('.has-nested-submenu');
								var belongsToLevel2 = false;
								level2Items.forEach(function(level2Item) {
									var level2ItemId = level2Item.className.match(/menu-item-(\d+)/);
									if (level2ItemId && level2ItemId[1] === level3ParentId) {
										belongsToLevel2 = true;
									}
								});
								if (belongsToLevel2) {
									level3.classList.remove('is-visible');
								}
							});
						}
					});
					// Hide all level 3 columns that don't belong to the target level 2
					var allLevel3Columns = contentArea.querySelectorAll('.mega-menu-columns--3');
					allLevel3Columns.forEach(function(level3) {
						var level3ParentId = level3.getAttribute('data-parent-item-id');
						// Check if this level 3 belongs to a different level 2
						var targetLevel2 = contentArea.querySelector('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]');
						if (targetLevel2) {
							var targetLevel2Items = targetLevel2.querySelectorAll('.has-nested-submenu');
							var belongsToTarget = false;
							targetLevel2Items.forEach(function(level2Item) {
								var level2ItemId = level2Item.className.match(/menu-item-(\d+)/);
								if (level2ItemId && level2ItemId[1] === level3ParentId) {
									belongsToTarget = true;
								}
							});
							if (!belongsToTarget) {
								level3.classList.remove('is-visible');
							}
						}
					});
				}
				
				// Close other nested items
				nestedItems.forEach(function(other) {
					if (other !== item) {
						other.classList.remove('is-nested-open');
					}
				});
				item.classList.add('is-nested-open');
				
				// Show nested column for this parent item
				if (contentArea) {
					var targetColumn = contentArea.querySelector('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]');
					if (targetColumn) {
						targetColumn.classList.add('is-visible');
					}
				}
			});
			
			item.addEventListener('mouseleave', function(e) {
				// Check if mouse is moving to the nested column (level 2 or level 3)
				var relatedTarget = e.relatedTarget;
				if (relatedTarget) {
					// Check if moving to level 2 column
					if (relatedTarget.closest('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]')) {
						// Mouse is moving to level 2 column, don't hide
						return;
					}
					// Check if moving to level 3 column (which is a child of level 2)
					if (relatedTarget.closest('.mega-menu-columns--3')) {
						// Mouse is moving to level 3 column, don't hide level 2
						return;
					}
					// Still over menu content (flex gaps / padding) — not a true leave toward the page
					if (contentArea && contentArea.contains(relatedTarget)) {
						return;
					}
				}

				nestedTimeout = setTimeout(function() {
					item.classList.remove('is-nested-open');
					// Hide nested column for this item
					if (contentArea) {
						var targetColumn = contentArea.querySelector('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]');
						if (targetColumn) {
							targetColumn.classList.remove('is-visible');
						}
					}
				}, NESTED_COLUMN_CLOSE_MS);
			});
			
			// Also handle mouseenter on nested column to keep it open
			if (contentArea) {
				var targetColumn = contentArea.querySelector('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]');
				if (targetColumn) {
					targetColumn.addEventListener('mouseenter', function() {
						clearTimeout(nestedTimeout);
						item.classList.add('is-nested-open');
						targetColumn.classList.add('is-visible');
					});
					
					targetColumn.addEventListener('mouseleave', function(e) {
						// Check if mouse is moving to level 3 column
						var relatedTarget = e.relatedTarget;
						if (relatedTarget) {
							if (relatedTarget.closest('.mega-menu-columns--3')) {
								return;
							}
							if (contentArea && contentArea.contains(relatedTarget)) {
								return;
							}
						}

						nestedTimeout = setTimeout(function() {
							item.classList.remove('is-nested-open');
							// Don't hide if this is a back-button navigation
							if (!targetColumn.hasAttribute('data-back-navigation')) {
								targetColumn.classList.remove('is-visible');
							}
						}, NESTED_COLUMN_CLOSE_MS);
					});
				}
			}
		});
		
		// Handle 3rd level menus (items within level 2 columns that have children) - Desktop only
		// Exclude mobile menus to prevent interference
		var thirdLevelItems = document.querySelectorAll('#desktop-main-menu .mega-menu-columns--2 .has-nested-submenu');
		var thirdLevelTimeout;
		thirdLevelItems.forEach(function(item) {
			// Skip if this is inside a mobile menu
			if (item.closest('.mobile-mega-menu')) return;
			
			// Extract menu item ID from class name
			var classMatch = item.className.match(/menu-item-(\d+)/);
			var parentItemId = classMatch ? classMatch[1] : null;
			
			if (!parentItemId) return;
			
			// Find the content area for this item's mega menu
			var megaMenuDropdown = item.closest('.mega-menu-dropdown');
			var contentArea = megaMenuDropdown ? megaMenuDropdown.querySelector('.mega-menu-content') : null;
			
			item.addEventListener('mouseenter', function() {
				clearTimeout(thirdLevelTimeout);
				clearTimeout(nestedTimeout); // Also clear level 2 timeout to keep it open
				
				// Find the parent level 2 column and ensure it stays visible
				var parentLevel2Column = item.closest('.mega-menu-columns--2');
				if (parentLevel2Column) {
					parentLevel2Column.classList.add('is-visible');
					// Find the level 1 item that owns this level 2 column
					var level2ParentId = parentLevel2Column.getAttribute('data-parent-item-id');
					if (level2ParentId) {
						var level1Item = contentArea ? contentArea.querySelector('.mega-menu-list .menu-item-' + level2ParentId) : null;
						if (level1Item) {
							level1Item.classList.add('is-nested-open');
						}
					}
				}
				
				// Hide all other 3rd level columns
				if (contentArea) {
					var allThirdLevelColumns = contentArea.querySelectorAll('.mega-menu-columns--3');
					allThirdLevelColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
				}
				
				// Close other 3rd level items
				thirdLevelItems.forEach(function(other) {
					if (other !== item) {
						other.classList.remove('is-nested-open');
					}
				});
				item.classList.add('is-nested-open');
				
				// Show 3rd level column for this parent item
				if (contentArea) {
					var targetColumn = contentArea.querySelector('.mega-menu-columns--3[data-parent-item-id="' + parentItemId + '"]');
					if (targetColumn) {
						targetColumn.classList.add('is-visible');
					}
				}
			});
			
			item.addEventListener('mouseleave', function(e) {
				var relatedTarget = e.relatedTarget;
				if (relatedTarget) {
					if (relatedTarget.closest('.mega-menu-columns--3[data-parent-item-id="' + parentItemId + '"]')) {
						return;
					}
					if (contentArea && contentArea.contains(relatedTarget)) {
						return;
					}
				}

				thirdLevelTimeout = setTimeout(function() {
					item.classList.remove('is-nested-open');
					// Hide 3rd level column for this item
					if (contentArea) {
						var targetColumn = contentArea.querySelector('.mega-menu-columns--3[data-parent-item-id="' + parentItemId + '"]');
						if (targetColumn) {
							targetColumn.classList.remove('is-visible');
						}
					}
				}, NESTED_COLUMN_CLOSE_MS);
			});
			
			// Also handle mouseenter on 3rd level column to keep it open
			if (contentArea) {
				var targetColumn = contentArea.querySelector('.mega-menu-columns--3[data-parent-item-id="' + parentItemId + '"]');
				if (targetColumn) {
					targetColumn.addEventListener('mouseenter', function() {
						clearTimeout(thirdLevelTimeout);
						clearTimeout(nestedTimeout); // Also clear level 2 timeout
						item.classList.add('is-nested-open');
						targetColumn.classList.add('is-visible');
					});
					
					targetColumn.addEventListener('mouseleave', function(e) {
						var relatedTarget = e.relatedTarget;
						if (relatedTarget && contentArea && contentArea.contains(relatedTarget)) {
							return;
						}
						thirdLevelTimeout = setTimeout(function() {
							item.classList.remove('is-nested-open');
							targetColumn.classList.remove('is-visible');
						}, NESTED_COLUMN_CLOSE_MS);
					});
				}
			}
		});
		
		// Close on click outside
		document.addEventListener('click', function(e) {
			var isInsideMenu = e.target.closest('.main-navigation, .mega-menu-dropdown, .sub-menu');
			if (!isInsideMenu) {
				topLevelItems.forEach(function(item) {
					item.classList.remove('is-open');
				});
			}
		});
		
		// Keyboard accessibility
		topLevelItems.forEach(function(item) {
			var link = item.querySelector('a');
			if (link) {
				link.addEventListener('keydown', function(e) {
					if (e.key === 'Enter' || e.key === ' ') {
						var dropdown = item.querySelector('.mega-menu-dropdown, .sub-menu');
						if (dropdown) {
							e.preventDefault();
							item.classList.toggle('is-open');
						}
					}
					if (e.key === 'Escape') {
						item.classList.remove('is-open');
						link.blur();
					}
				});
			}
		});
		
		// Escape key closes all menus
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				topLevelItems.forEach(function(item) {
					item.classList.remove('is-open');
				});
			}
		});
		
		// No need to recalculate positions - columns are in the same grid and auto-position
		
		// ==========================================================================
		// MOBILE MEGA MENU - ACCORDION FUNCTIONALITY
		// ==========================================================================
		
		// Mobile menu items with mega menu - Show level 1
		var mobileMegaMenuItems = document.querySelectorAll('.mobile-mega-menu > li.has-mega-menu');
		mobileMegaMenuItems.forEach(function(item) {
			var link = item.querySelector('a');
			var dropdown = item.querySelector('.mega-menu-dropdown');
			
			if (!link || !dropdown) return;
			
			link.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Close other open mega menus
				mobileMegaMenuItems.forEach(function(otherItem) {
					if (otherItem !== item) {
						otherItem.classList.remove('is-open');
						var otherDropdown = otherItem.querySelector('.mega-menu-dropdown');
						if (otherDropdown) {
							otherDropdown.classList.remove('is-open');
							// Hide all columns in other dropdowns
							var otherColumns = otherDropdown.querySelectorAll('.mega-menu-columns');
							otherColumns.forEach(function(col) {
								col.classList.remove('is-visible');
							});
						}
					}
				});
				
				// Open current mega menu dropdown
				item.classList.add('is-open');
				dropdown.classList.add('is-open');
				
				// Show level 1 (columns without data-parent-item-id attribute)
				var firstColumns = dropdown.querySelector('.mega-menu-columns:not([data-parent-item-id])');
				if (firstColumns) {
					// Hide all columns first
					var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
					allColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					// Show only level 1
					firstColumns.classList.add('is-visible');
					// Show sidebar and featured for level 1
					var sidebar = dropdown.querySelector('.mega-menu-sidebar');
					if (sidebar) {
						sidebar.style.display = 'block';
					}
					var featured = dropdown.querySelector('.mega-menu-featured');
					if (featured) {
						featured.style.display = 'flex';
					}
					
					// Show news grid for news_grid and manual_posts layouts
					var newsGrid = dropdown.querySelector('.mega-menu-news');
					if (newsGrid) {
						newsGrid.style.display = 'block';
					}
					
					// Note: Submenu content (mega-menu-content) is not rendered in PHP for news_grid 
					// and manual_posts layouts, so no need to handle it here
					
					// Ensure back button is visible and functional
					var backButton = dropdown.querySelector('.mega-menu-back-button');
					if (backButton) {
						backButton.style.display = 'flex';
					}
				}
			});
		});
		
		// Back button functionality - Go back one level (use event delegation)
		// Use capture phase to ensure this runs before other click handlers
		document.addEventListener('click', function(e) {
			// Check if the clicked element is a back button or inside one
			var button = e.target.closest('.mega-menu-back-button');
			if (!button) return;
			
			// Prevent any default behavior and stop all propagation
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			
			// Also check if we're inside a link and prevent that too
			var link = e.target.closest('a');
			if (link && link.href) {
				e.preventDefault();
			}
			
			var dropdown = button.closest('.mega-menu-dropdown');
			if (!dropdown) return;
			
			var sidebar = dropdown.querySelector('.mega-menu-sidebar');
			var featured = dropdown.querySelector('.mega-menu-featured');
			
			// Find all visible columns
			var visibleColumns = dropdown.querySelectorAll('.mega-menu-columns.is-visible');
			
			// If no visible columns, close the dropdown
			if (visibleColumns.length === 0) {
				// Hide all columns
				var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
				allColumns.forEach(function(col) {
					col.classList.remove('is-visible');
				});
				
				dropdown.classList.remove('is-open');
				var parentItem = dropdown.closest('li.has-mega-menu');
				if (parentItem) {
					parentItem.classList.remove('is-open');
				}
				return;
			}
			
			// Get the last visible column (current level)
			var currentColumn = visibleColumns[visibleColumns.length - 1];
			
			// Determine the level using data-parent-item-id attribute
			// Level 1: NO data-parent-item-id
			// Level 2: HAS data-parent-item-id AND class contains --2
			// Level 3: HAS data-parent-item-id AND class contains --3
			var hasParentId = currentColumn.hasAttribute('data-parent-item-id');
			var isLevel3 = hasParentId && currentColumn.classList.contains('mega-menu-columns--3');
			var isLevel2 = hasParentId && currentColumn.classList.contains('mega-menu-columns--2');
			var isLevel1 = !hasParentId; // Level 1 columns don't have data-parent-item-id
				
				// If current is level 3, go back to level 2
				if (isLevel3) {
					var level3ParentId = currentColumn.getAttribute('data-parent-item-id');
					var fromLevel2Id = currentColumn.getAttribute('data-from-level2');
					
					// Hide current level 3
					currentColumn.classList.remove('is-visible');
					
					// Hide all columns first to ensure clean state
					var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
					allColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					
					var targetLevel2Column = null;
					
					// First, try to find the level 2 column we came from (stored in data-from-level2)
					// data-from-level2 contains the data-parent-item-id of the level 2 column
					if (fromLevel2Id && fromLevel2Id !== '') {
						// Find level 2 column where data-parent-item-id matches fromLevel2Id
						targetLevel2Column = dropdown.querySelector('.mega-menu-columns--2[data-parent-item-id="' + fromLevel2Id + '"]');
					}
					
					// If not found, find the level 2 column that contains the level 2 item with the parent ID
					// The level3ParentId is the ID of the level 2 menu item that has level 3 children
					if (!targetLevel2Column && level3ParentId) {
						var allLevel2Columns = dropdown.querySelectorAll('.mega-menu-columns--2[data-parent-item-id]');
						allLevel2Columns.forEach(function(level2Col) {
							// Check if this level 2 column contains a menu item with the level3ParentId
							var level2Item = level2Col.querySelector('.menu-item-' + level3ParentId);
							if (level2Item) {
								targetLevel2Column = level2Col;
							}
						});
					}
					
					// If still not found, try to find any level 2 column that was visible before
					// This is a fallback - we'll use the first level 2 column
					if (!targetLevel2Column) {
						var firstLevel2Column = dropdown.querySelector('.mega-menu-columns--2[data-parent-item-id]');
						if (firstLevel2Column) {
							targetLevel2Column = firstLevel2Column;
						}
					}
					
						// Show the target level 2 column
						if (targetLevel2Column) {
							// Add a data attribute to mark this as a back-button navigation
							// This prevents desktop hover handlers from interfering
							targetLevel2Column.setAttribute('data-back-navigation', 'true');
							
							// Add the class immediately
							targetLevel2Column.classList.add('is-visible');
							
							// Use requestAnimationFrame as a safeguard to ensure it stays
							requestAnimationFrame(function() {
								if (!targetLevel2Column.classList.contains('is-visible')) {
									targetLevel2Column.classList.add('is-visible');
								}
								
								// Double-check after a brief delay to ensure it's still there
								setTimeout(function() {
									if (!targetLevel2Column.classList.contains('is-visible')) {
										targetLevel2Column.classList.add('is-visible');
									}
								}, 100);
								
								// Remove the back-navigation flag after a delay to allow normal interactions
								setTimeout(function() {
									targetLevel2Column.removeAttribute('data-back-navigation');
								}, 500);
							});
							
							// Hide sidebar, featured, and news grid for level 2
							if (sidebar) {
								sidebar.style.display = 'none';
								sidebar.style.visibility = 'hidden';
							}
							if (featured) {
								featured.style.display = 'none';
							}
							var newsGrid = dropdown.querySelector('.mega-menu-news');
							if (newsGrid) {
								newsGrid.style.display = 'none';
							}
						} else {
							// If we can't find level 2, go back to level 1 as fallback
							var level1Columns = dropdown.querySelectorAll('.mega-menu-columns:not([data-parent-item-id])');
							if (level1Columns.length > 0) {
								level1Columns[0].classList.add('is-visible');
								
								// Show sidebar if it has content
								if (sidebar) {
									var sidebarContent = sidebar.querySelector('.mega-menu-sidebar__content');
									var hasSidebarContent = sidebarContent && sidebarContent.innerHTML.trim() !== '';
									var isHiddenByDefault = sidebar.hasAttribute('style') && sidebar.getAttribute('style').includes('display: none');
									
									if (hasSidebarContent && !isHiddenByDefault) {
										sidebar.style.display = 'block';
										sidebar.style.visibility = 'visible';
									} else {
										sidebar.style.display = 'none';
										sidebar.style.visibility = 'hidden';
									}
								}
								if (featured) {
									featured.style.display = 'flex';
								}
								var newsGrid = dropdown.querySelector('.mega-menu-news');
								if (newsGrid) {
									newsGrid.style.display = 'block';
								}
								// Note: Submenu content is not rendered for news_grid/manual_posts layouts
							}
						}
				}
				// If current is level 2, go back to level 1
				else if (isLevel2) {
					// Hide current level 2
					currentColumn.classList.remove('is-visible');
					
					// Show level 1 (columns without data-parent-item-id attribute)
					var level1Columns = dropdown.querySelectorAll('.mega-menu-columns:not([data-parent-item-id])');
					if (level1Columns.length > 0) {
						// Show the first level 1 column
						level1Columns[0].classList.add('is-visible');
						// Show sidebar, featured, and news grid for level 1
						if (sidebar) {
							// Check if sidebar has content (mega menus always have at least a title)
							var sidebarContent = sidebar.querySelector('.mega-menu-sidebar__content');
							var hasSidebarContent = sidebarContent && sidebarContent.innerHTML.trim() !== '';
							
							// Check if this is a regular submenu (sidebar was hidden by default in PHP)
							// Regular submenus have sidebar with style="display: none;" from PHP
							var isRegularSubmenu = sidebar.hasAttribute('style') && 
							                      sidebar.getAttribute('style').includes('display: none');
							
							// Show sidebar if:
							// 1. It has content (mega menu with sidebar content), OR
							// 2. It's not a regular submenu (mega menu without explicit hide)
							if (hasSidebarContent || !isRegularSubmenu) {
								sidebar.style.display = 'block';
								sidebar.style.visibility = 'visible';
							} else {
								// Regular submenu without content - keep it hidden
								sidebar.style.display = 'none';
								sidebar.style.visibility = 'hidden';
							}
						}
						if (featured) {
							featured.style.display = 'flex';
						}
						var newsGrid = dropdown.querySelector('.mega-menu-news');
						if (newsGrid) {
							newsGrid.style.display = 'block';
						}
						// Note: Submenu content is not rendered for news_grid/manual_posts layouts
					}
				}
				// If current is level 1, close dropdown
				else if (isLevel1) {
					// Hide all visible columns first
					visibleColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					
					// Hide all columns in the dropdown
					var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
					allColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					
					// Close the dropdown - remove is-open class
					dropdown.classList.remove('is-open');
					
					// Find and close the parent menu item
					var parentItem = dropdown.closest('li.has-mega-menu');
					if (parentItem) {
						parentItem.classList.remove('is-open');
					}
					
					// Also try to find parent by traversing up
					if (!parentItem) {
						// Try alternative method to find parent
						var menuItem = dropdown.parentElement;
						if (menuItem && menuItem.classList.contains('has-mega-menu')) {
							menuItem.classList.remove('is-open');
						}
					}
					
					// Also try to find parent by looking for the menu item that contains this dropdown
					if (!parentItem) {
						// Search in the mobile menu for the item that contains this dropdown
						var mobileMenuItems = document.querySelectorAll('.mobile-mega-menu > li.has-mega-menu');
						mobileMenuItems.forEach(function(item) {
							var itemDropdown = item.querySelector('.mega-menu-dropdown');
							if (itemDropdown === dropdown) {
								item.classList.remove('is-open');
								parentItem = item;
							}
						});
					}
					
					// Hide sidebar, featured, and news grid when closing dropdown
					if (sidebar) {
						sidebar.style.display = 'none';
					}
					if (featured) {
						featured.style.display = 'none';
					}
					var newsGrid = dropdown.querySelector('.mega-menu-news');
					if (newsGrid) {
						newsGrid.style.display = 'none';
					}
					
					// Force a reflow to ensure CSS updates
					dropdown.offsetHeight;
					
					// Ensure the dropdown is fully hidden after transition
					setTimeout(function() {
						if (!dropdown.classList.contains('is-open')) {
							// Double-check all columns are hidden
							allColumns.forEach(function(col) {
								col.classList.remove('is-visible');
							});
							
							// Ensure sidebar, featured, and news grid are hidden
							if (sidebar) {
								sidebar.style.display = 'none';
							}
							if (featured) {
								featured.style.display = 'none';
							}
							var newsGrid = dropdown.querySelector('.mega-menu-news');
							if (newsGrid) {
								newsGrid.style.display = 'none';
							}
						}
					}, 350); // Wait for CSS transition to complete (0.3s = 300ms, add 50ms buffer)
				}
				// Fallback: if we can't determine the level, close the dropdown
				else {
					console.warn('Could not determine menu level, closing dropdown');
					// Hide all visible columns
					visibleColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					
					// Hide all columns in the dropdown
					var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
					allColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
					
					// Close the dropdown
					dropdown.classList.remove('is-open');
					var parentItem = dropdown.closest('li.has-mega-menu');
					if (parentItem) {
						parentItem.classList.remove('is-open');
					}
				}
		});
		
		// Close all mega menus when main mobile menu closes
		var mobileNavigation = document.getElementById('mobile-navigation');
		if (mobileNavigation) {
			var observer = new MutationObserver(function(mutations) {
				if (!mobileNavigation.classList.contains('active')) {
					// Close all open mega menu dropdowns
					var openDropdowns = document.querySelectorAll('.mobile-mega-menu .mega-menu-dropdown.is-open');
					openDropdowns.forEach(function(dropdown) {
						dropdown.classList.remove('is-open');
						var parentItem = dropdown.closest('li.has-mega-menu');
						if (parentItem) {
							parentItem.classList.remove('is-open');
						}
					});
					
					// Close all visible columns
					var openColumns = document.querySelectorAll('.mobile-mega-menu .mega-menu-columns.is-visible');
					openColumns.forEach(function(col) {
						col.classList.remove('is-visible');
					});
				}
			});
			
			observer.observe(mobileNavigation, {
				attributes: true,
				attributeFilter: ['class']
			});
		}
		
		// Mobile navigation for level 1 -> level 2
		var mobileLevel1Items = document.querySelectorAll('.mobile-mega-menu .mega-menu-columns:not([data-parent-item-id]) .has-nested-submenu');
		mobileLevel1Items.forEach(function(item) {
			var link = item.querySelector('.menu-link');
			if (!link) return;
			
			var classMatch = item.className.match(/menu-item-(\d+)/);
			var parentItemId = classMatch ? classMatch[1] : null;
			if (!parentItemId) return;
			
			var dropdown = item.closest('.mega-menu-dropdown');
			if (!dropdown) return;
			
			var targetColumn = dropdown.querySelector('.mega-menu-columns--2[data-parent-item-id="' + parentItemId + '"]');
			if (!targetColumn) return;
			
			link.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Hide level 1, show level 2
				var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
				allColumns.forEach(function(col) {
					col.classList.remove('is-visible');
				});
				targetColumn.classList.add('is-visible');
				
				// Hide sidebar, featured, and news grid when showing level 2
				var sidebar = dropdown.querySelector('.mega-menu-sidebar');
				if (sidebar) {
					sidebar.style.display = 'none';
					sidebar.style.visibility = 'hidden';
				}
				var featured = dropdown.querySelector('.mega-menu-featured');
				if (featured) {
					featured.style.display = 'none';
				}
				var newsGrid = dropdown.querySelector('.mega-menu-news');
				if (newsGrid) {
					newsGrid.style.display = 'none';
				}
			});
		});
		
		// ==========================================================================
		// REGULAR SUBMENUS (Non-Mega Menu) - Full Width Overlay Functionality
		// ==========================================================================
		
		// Handle regular submenu items (non-mega menu) - Level 1
		// Now uses mega menu structure, so we can use the same logic as mega menus
		var regularSubmenuItems = document.querySelectorAll('.mobile-mega-menu > li.menu-item-has-children:not(.has-mega-menu)');
		regularSubmenuItems.forEach(function(item) {
			var link = item.querySelector('a');
			var dropdown = item.querySelector('.mega-menu-dropdown');
			
			if (!link || !dropdown) return;
			
			link.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Close other open mega menu dropdowns at same level
				var allDropdowns = document.querySelectorAll('.mobile-mega-menu .mega-menu-dropdown.is-open');
				allDropdowns.forEach(function(otherDropdown) {
					if (otherDropdown !== dropdown) {
						otherDropdown.classList.remove('is-open');
						var otherParent = otherDropdown.closest('li');
						if (otherParent) {
							otherParent.classList.remove('is-open');
						}
					}
				});
				
				// Open current dropdown
				item.classList.add('is-open');
				dropdown.classList.add('is-open');
				
				// Show level 1 column
				var level1Column = dropdown.querySelector('.mega-menu-columns--1');
				if (level1Column) {
					level1Column.classList.add('is-visible');
				}
			});
		});
		
		// Handle nested submenu items (Level 2 and 3) - Use event delegation
		// Now works with unified mega menu structure for both mega menus and regular submenus
		document.addEventListener('click', function(e) {
			var link = e.target.closest('.mobile-mega-menu .mega-menu-list .menu-link, .mobile-mega-menu .mega-menu-list a');
			if (!link) return;
			
			var listItem = link.closest('li');
			if (!listItem) return;
			
			// Skip if clicking on back button
			if (link.closest('.mega-menu-back-button')) return;
			
			// Check if this item has children (nested submenu/column)
			var hasNestedSubmenu = listItem.classList.contains('has-nested-submenu') || listItem.classList.contains('menu-item-has-children');
			if (hasNestedSubmenu) {
				// This item has children, show nested column
				e.preventDefault();
				
				var dropdown = listItem.closest('.mega-menu-dropdown');
				if (!dropdown) return;
				
				// Get the item ID to find the target column
				var itemId = listItem.className.match(/menu-item-(\d+)/);
				if (!itemId) return;
				var itemIdNum = itemId[1];
				
				// Find the target column (level 2 or 3)
				var targetColumn = dropdown.querySelector('.mega-menu-columns--2[data-parent-item-id="' + itemIdNum + '"], .mega-menu-columns--3[data-parent-item-id="' + itemIdNum + '"]');
				if (!targetColumn) return;
				
				// Hide all visible columns first
				var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
				allColumns.forEach(function(col) {
					col.classList.remove('is-visible');
				});
				
				// Show target column
				targetColumn.classList.add('is-visible');
				
				// Hide sidebar, featured, and news grid when showing nested columns
				var sidebar = dropdown.querySelector('.mega-menu-sidebar');
				if (sidebar) {
					sidebar.style.display = 'none';
				}
				var featured = dropdown.querySelector('.mega-menu-featured');
				if (featured) {
					featured.style.display = 'none';
				}
				var newsGrid = dropdown.querySelector('.mega-menu-news');
				if (newsGrid) {
					newsGrid.style.display = 'none';
				}
			}
			// If no nested submenu, allow normal link navigation
		});
		
		// Regular submenus now use the same mega menu structure
		// So the mega menu back button handler (above) will work for both automatically!
		// No separate handler needed - this is the beauty of the unified structure!
		
		// Mobile navigation for level 2 -> level 3
		var mobileLevel2Items = document.querySelectorAll('.mobile-mega-menu .mega-menu-columns--2 .has-nested-submenu');
		mobileLevel2Items.forEach(function(item) {
			var link = item.querySelector('.menu-link');
			if (!link) return;
			
			var classMatch = item.className.match(/menu-item-(\d+)/);
			var parentItemId = classMatch ? classMatch[1] : null;
			if (!parentItemId) return;
			
			var dropdown = item.closest('.mega-menu-dropdown');
			if (!dropdown) return;
			
			var targetColumn = dropdown.querySelector('.mega-menu-columns--3[data-parent-item-id="' + parentItemId + '"]');
			if (!targetColumn) return;
			
			link.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Store which level 2 column we're coming from
				// This stores the data-parent-item-id of the level 2 column (which is the level 1 item ID)
				var currentLevel2Column = item.closest('.mega-menu-columns--2');
				if (currentLevel2Column) {
					var level2ParentId = currentLevel2Column.getAttribute('data-parent-item-id');
					if (level2ParentId) {
						targetColumn.setAttribute('data-from-level2', level2ParentId);
					}
				}
				
				// Hide level 2, show level 3
				var allColumns = dropdown.querySelectorAll('.mega-menu-columns');
				allColumns.forEach(function(col) {
					col.classList.remove('is-visible');
				});
				targetColumn.classList.add('is-visible');
				
				// Hide sidebar, featured, and news grid when showing level 3
				var sidebar = dropdown.querySelector('.mega-menu-sidebar');
				if (sidebar) {
					sidebar.style.display = 'none';
					sidebar.style.visibility = 'hidden';
				}
				var featured = dropdown.querySelector('.mega-menu-featured');
				if (featured) {
					featured.style.display = 'none';
				}
				var newsGrid = dropdown.querySelector('.mega-menu-news');
				if (newsGrid) {
					newsGrid.style.display = 'none';
				}
			});
		});
	});
})();

